export default "__VITE_ASSET__JMd5BiKH__"